import { atom } from "jotai";

export const categoryAtom = atom(null);
